export default __webpack_public_path__ + "static/media/Cloud2.2ca4e337.png";